import { z } from "zod"

import { LeadTimeUnits, ProductStockType } from "@/graphql/codegen/graphql"

const SAFETY_STOCK_MAX = 9999999 // AS400 constraint

export const productWarehouseFormSchema = z.object({
  warehouseAreaId: z.string().min(1, "Warehouse is required"),
  isActive: z.boolean(),
  safetyStock: z
    .number()
    .int("Only whole numbers are allowed")
    .refine(
      (val) => val >= 0 && val <= SAFETY_STOCK_MAX,
      `Akrochem Safety Stock must be between 0 and ${SAFETY_STOCK_MAX}`
    )
    .nullable(),
  stockType: z.nativeEnum(ProductStockType).nullable(),
  hasCombinedPricing: z.boolean(),
  isOnAllocation: z.boolean(),
  weightPerTruckload: z.number().int("Only whole numbers are allowed").min(0).nullable(),
  leadTime: z.number().int("Only whole numbers are allowed").min(0).nullable(),
  leadTimeUnit: z.nativeEnum(LeadTimeUnits),
  minOrderQuantity: z.number().int("Only whole numbers are allowed").min(0).nullable(),
})

export type ProductWarehouseFormValues = z.infer<typeof productWarehouseFormSchema>
